import React from 'react';
import VoiceToTextTextarea from '@components/VoiceToTextTextarea';
import getVoiceToTextBlockedMessages from './VoiceTranscribing/utils';
import { AboutMeTypes } from '../StepThreeTypes';

interface MyWellnessProps {
  aboutMe: AboutMeTypes;
  setAboutMe: (aboutMe: AboutMeTypes) => void;
}

const PleaseDoAndDoNot: React.FC<MyWellnessProps> = ({
  aboutMe,
  setAboutMe,
}) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h1 className="govuk-label-wrapper">
        <label
          className="govuk-label govuk-label--l"
          htmlFor="please-do-and-do-not"
        >
          Please do and please do not
        </label>
      </h1>
      <div className="govuk-body">
        A description of things you want someone supporting you to do (or not to
        do).
        <br />
        <br />
        Things you want someone to do might include (for example): Talk to me
        not to my carer, remind me to take my medication, encourage me to wash
        my hands regularly, explain to me what is happening and why, respond to
        my communication.
        <br />
        <br />A description of things you do not want someone supporting you to
        do might include (for example): Discussing or asking questions about
        certain topics, making assumptions about something, providing support
        when it is not wanted, talking to you in a certain way, or asking you to
        undergo a specific intervention or to take a medication that you do not
        want.
      </div>

      <details className="govuk-details">
        <summary className="govuk-details__summary">
          <span className="govuk-details__summary-text">Prompt questions</span>
        </summary>
        <div className="govuk-details__text">
          <div className="govuk-body">
            1. What are the really important things that you want someone to do
            when caring for or supporting you?
          </div>
          <div className="govuk-body">
            2. What are the really important things that you don’t want someone
            to do when caring for or supporting you?
          </div>
        </div>
      </details>

      <VoiceToTextTextarea
        id="please-do-and-do-not"
        name="plsdoAndonot"
        value={aboutMe.plsdoAndonot || ''}
        rows={5}
        autoComplete="please-do-and-do-not"
        placeholder="Type here or use voice to text..."
        recordBlockedErrors={getVoiceToTextBlockedMessages(aboutMe)}
        onChange={value => setAboutMe({ ...aboutMe, plsdoAndonot: value })}
      />
    </div>
  );
};

export default PleaseDoAndDoNot;
